var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"container-loader position-fixed d-flex justify-content-center align-items-center"},[_c('b-spinner',{attrs:{"large":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }